/**
 * Chemins publics de l'application.
 * Source unique pour le routage et la navigation : les features et la coquille
 * référencent ces constantes plutôt que des chaînes en dur, ce qui facilitera
 * le découplage lors de l'évolution vers des microfrontends.
 */
export const paths = {
  home: '/',
  login: '/login',
  dashboard: '/dashboard',
  receipts: '/receipts',
  receiptNew: '/receipts/new',
  expenses: '/expenses',
  analytics: '/analytics',
  ai: '/ai',
  settings: '/settings',
  help: '/help',
} as const;
